import React from 'react'
import {Form, Message} from 'semantic-ui-react'
import {connect} from 'react-redux'
import {updateAccountDetails} from '../../../actions/account.action'

const {Field, Button} = Form

const ProfileContainer = class ProfileContainer extends React.Component {
  constructor (props, context) {
    super(props, context)
    const {account} = props

    this.state = {
      isLoading: false,
      isSuccess: false,
      hasError: false,
      error: null,
      form: {
        email: account.email,
        first_name: account.first_name,
        last_name: account.last_name
      }
    }

    this.onChange = this.onChange.bind(this)
    this.updateProfile = this.updateProfile.bind(this)
  }
  updateProfile (e) {
    const {form} = this.state
    const {email, first_name, last_name} = form
    e.preventDefault()
    this.props.updateAccountDetails({email, first_name, last_name}, () => {
      this.setState({
        error: null,
        hasError: false,
        isLoading: false,
        isSuccess: true
      })
    }, (error) => {
      this.setState({
        error,
        isLoading: false,
        isSuccess: false,
        hasError: true
      })
    })
  }
  onChange (e) {
    const oldFormState = this.state.form
    const updatedForm = Object.assign({}, oldFormState, {
      [e.target.name]: e.target.value
    })
    this.setState({
      form: updatedForm
    })
  }
  render () {
    const {account} = this.props
    const {isLoading, isSuccess, form} = this.state
    return (
      <div>
        <h2>Profile</h2>

        <Form onSubmit={this.updateProfile.bind(this)} loading={isLoading} success={isSuccess}>
          <Message success>
            <Message.Header>Profile settings updated</Message.Header>
          </Message>
          <Field>
            <label htmlFor='email'>Email</label>
            <input autoFocus type='email' value={form.email} id='email' name='email' onChange={this.onChange} />
          </Field>
          <Field>
            <label htmlFor='first_name'>First name</label>
            <input autoFocus value={form.first_name} id='first_name' name='first_name' onChange={this.onChange} />
          </Field>
          <Field>
            <label htmlFor='last_name'>Last name</label>
            <input autoFocus value={form.last_name} id='last_name' name='last_name' onChange={this.onChange} />
          </Field>
          <Field>
            <label>Timezone</label>
            <p>{account.timezone}</p>
          </Field>
          <Field>
            <label>Company</label>
            <p>{account.locations_data[0] && account.locations_data[0].name}</p>
          </Field>

          <Button primary type='submit'>Update profile</Button>
        </Form>
      </div>
    )
  }
}

// ProfileContainer.propTypes = {
//   account: PropTypes.observableObject
// }

function mapStateToProps (state) {
  return {account: state.account.user}
}

export default connect(mapStateToProps, {updateAccountDetails})(ProfileContainer)



// WEBPACK FOOTER //
// ./src/pages/settings/profile/index.js